import { useFormikContext } from 'formik';
import { Prompt } from 'react-router';
import React from 'react';
import { Render } from 'types';

export function DirtyPrompt(): Render {
  const context = useFormikContext();
  return <Prompt when={context.dirty} message='You have unsaved changes, are you sure you want to leave?' />;
}
